module.exports = __webpack_public_path__ + "static/media/20170806_04day_0183AT.5114aa3a.jpg";